import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Grid,
} from "@mui/material";

export default function DataSummaryHeader() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const host = window.location.protocol + "//" + window.location.hostname;
    const endpoint = host + process.env.REACT_APP_API_DATA_VOLUME_SUMMARY;

    setLoading(true);
    setError(null);

    fetch(endpoint)
      .then((res) => {
        if (res.status === 503) {
          throw new Error("Data summary cache not ready yet.");
        }
        return res.json();
      })
      .then((data) => setSummary(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Card sx={{ mb: 3, p: 3, textAlign: "center" }}>
        <CircularProgress />
      </Card>
    );
  }

  if (error) {
    return (
      <Card sx={{ mb: 3, p: 3, textAlign: "center" }}>
        <Typography color="error">{error}</Typography>
      </Card>
    );
  }

  if (!summary) {
    return (
      <Card sx={{ mb: 3, p: 3, textAlign: "center" }}>
        <Typography>No summary data available.</Typography>
      </Card>
    );
  }

  const formatSize = (gb) => `${gb.toFixed(2)} GB`;

  return (
    <Card
      sx={{
        mb: 3,
        p: 2,
        boxShadow: 3,
        borderRadius: 3,
        backgroundColor: "background.paper",
      }}
    >
      <CardContent sx={{ py: 1.5 }}>
        <Typography variant="h6" gutterBottom align="center">
          Archive Data Volume Summary
        </Typography>

        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} sm={4}>
            <Typography variant="h5" fontWeight="bold">
              {summary.total_files.toLocaleString()}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Files
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h5" fontWeight="bold">
              {formatSize(summary.total_size_gb)}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Total Size
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h5" fontWeight="bold">
              {summary.total_days}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Nights Archived
            </Typography>
          </Grid>
        </Grid>
      </CardContent>

    </Card>
  );
}
